import { TRatiosHistoricos } from "../../../services/OmniaService";
import { TRatiosCarterasDBModel } from "../../Portfolios/File/types/CarteraRatioTypes";

type TDataFromSimulationToTableProps = {
    ratiosHistoricos: TRatiosHistoricos[];
    option: string;
}

export const dataFromSimulationToTable = ({ ratiosHistoricos, option }: TDataFromSimulationToTableProps) =>{
    const walletName = option === "Original" ? "Original" : "Nuevo";
    
    const formatedData: TRatiosCarterasDBModel[] = ratiosHistoricos.map(items => {
            return {
                nomcontrato: items.portfolioId,
                dateCalculation: items.date,
                period: items.period,
                ratio: items.ratio,
                valueCartera: option === "Original" ? items.modelo : items.cartera
            }
        });
    return {
        name: walletName,
        data: formatedData
    }
}
    
